import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../../.sourceflow/metadata.json";

export default function SeoHead({
    site_name = "Global Recruitment | Xcede Group",
    page_name = "Global Recruitment | Xcede Group",
    description = "We are the Xcede Group, a global recruitment business working across every aspect of STEM innovation. Explore our brands.",
    canonical_link = "https://www.xcedegroup.com",
    og_image = "https://cdn.sourceflow.co.uk/lnbos2zk07150v2300f4ztml76su",
    og_img_alt = "Global Recruitment | Xcede Group",
    robots=""
}) {
    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                siteName={site_name}
                title={page_name}
                description={description}
                canonical={canonical_link}
                robots={robots}
                additionalMetaTags={[
                    {
                        property: 'title',
                        content: page_name
                    },
                ]}
                images={[
                    {
                        url: og_image,
                        width: 1200,
                        height: 600,
                        alt: og_img_alt,
                        type: "image/jpeg",
                    },
                ]}
            />
        </>
    )
}
